module.exports = __webpack_public_path__ + "static/img/bottom1.c3db2f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/bottom1.jpg
// module id = rdK6
// module chunks = 1